var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { CpaProductMetadata } from '@millerknoll/pub-api-schema';
import { useCpaProduct } from 'components/Cpa/CpaProduct/CpaProductContextProvider';
import { ActionType, InputFieldType } from 'models/Input/InputModels';
import { InputFieldsContainer } from 'components/Shared/InputFieldsContainer/InputFieldsContainer';
import { inputFieldsContainerHelper } from 'components/Shared/InputFieldsContainer/InputFieldsContainerHelper';
import { LoadingSpinner } from 'components/Shared/Loading/LoadingSpinner/LoadingSpinner';
import { useLookupSearch } from 'hooks/useLookupSearch';
import { LookupType } from 'services/api/search-service';
import { useProductValidate } from 'hooks/useProductValidate';
import { createLock, customCpaProductHeaderErrors } from 'utils/cpa-utils';
import { getUserOrSignIn } from 'services/auth/AuthService';
import { useBanner, BannerMessageType, BannerIconType } from 'components/Shared/BannerContext/BannerContext';
var PRODUCT_LINE_CODE_FIELD_NAME = 'productLineCode';
var STANDARD_PRODUCT_REF_FIELD_NAME = 'standardProductReference';
var DISCOUNT_CODE_FIELD_NAME = 'discountCode';
var PRODUCT_NAME = 'productName';
var CPN_FIELD_NAME = 'cpn';
var REQUESTOR = 'requestor';
export function CpaProductHeaderAdditionalInfoWorkOrder() {
    var _a;
    var _this = this;
    var _b, _c, _d;
    var cpaProductContext = useCpaProduct();
    var _e = useBanner(), setBannerMessage = _e.setBannerMessage, setBannerType = _e.setBannerType, setBannerIcon = _e.setBannerIcon, setShowBanner = _e.setShowBanner, setIsRefreshEnabled = _e.setIsRefreshEnabled;
    /**
     * Declare state to hold field values of all columns , key as column heading
     */
    var _f = useState(buildFieldValues(undefined, undefined)), fieldValues = _f[0], setFieldValues = _f[1];
    var productLineValidate = useLookupSearch(LookupType.ProductLine, (_b = fieldValues[PRODUCT_LINE_CODE_FIELD_NAME].value) === null || _b === void 0 ? void 0 : _b.trim());
    var discountCodeValidate = useLookupSearch(LookupType.DiscountCode, (_c = fieldValues[DISCOUNT_CODE_FIELD_NAME].value) === null || _c === void 0 ? void 0 : _c.trim());
    var standardProductReferenceValidate = useProductValidate(fieldValues[STANDARD_PRODUCT_REF_FIELD_NAME].value, 'Standard Product Ref', undefined, ((_d = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.currentProductMetadata) === null || _d === void 0 ? void 0 : _d.sourceSystem) === CpaProductMetadata.sourceSystem.CSP);
    /**
     * Holds Column Definition and Initial Values of the Column
     */
    var colDef = {
        rowGap: '4px',
        title: { displayText: 'Product Information', marginBottom: '16px' },
        showActions: true,
        preventReadOnly: true,
        disabled: cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.isEditDisabled,
        fields: (_a = {},
            _a[CPN_FIELD_NAME] = {
                fieldName: 'Custom Product Number:',
                displaySeq: 0,
                hasLookup: false,
                input: {
                    type: InputFieldType.READONLY,
                },
            },
            _a[STANDARD_PRODUCT_REF_FIELD_NAME] = {
                fieldName: 'Standard Product Number:',
                displaySeq: 1,
                hasLookup: false,
                input: {
                    type: InputFieldType.STRING,
                    validations: {
                        noSpaces: 'Invalid input. No spaces allowed.',
                        maxLength: 250,
                    },
                },
            },
            _a[PRODUCT_LINE_CODE_FIELD_NAME] = {
                fieldName: 'Product Line (Code):',
                displaySeq: 2,
                hasLookup: true,
                input: {
                    type: InputFieldType.STRING,
                    validations: {
                        maxLength: 10,
                        validate: function (value) {
                            var _a;
                            return customCpaProductHeaderErrors(value, (_a = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.currentProduct) === null || _a === void 0 ? void 0 : _a.businessUnitCode);
                        },
                    },
                },
            },
            _a[DISCOUNT_CODE_FIELD_NAME] = {
                fieldName: 'Discount (Code):',
                displaySeq: 3,
                hasLookup: true,
                input: {
                    type: InputFieldType.STRING,
                    validations: {
                        maxLength: 10,
                        required: 'Required field.',
                    },
                },
            },
            _a[PRODUCT_NAME] = {
                fieldName: 'Description:',
                displaySeq: 4,
                hasLookup: false,
                input: {
                    type: InputFieldType.STRING,
                    validations: {
                        maxLength: 255,
                    },
                },
            },
            _a[REQUESTOR] = {
                fieldName: 'Requestor:',
                displaySeq: 5,
                hasLookup: false,
                input: {
                    type: InputFieldType.STRING,
                    validations: {
                        required: 'Required field.',
                        maxLength: 80,
                    },
                },
            },
            _a),
    };
    useEffect(function () {
        var _a;
        if (!((_a = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data) === null || _a === void 0 ? void 0 : _a.currentProduct) || !cpaProductContext.data.cpn) {
            return;
        }
        setFieldValues(buildFieldValues(cpaProductContext.data.currentProduct, cpaProductContext.data.cpn));
    }, [cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.currentProduct, cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn]);
    useEffect(function () {
        setFieldValues(function (cur) {
            cur[PRODUCT_LINE_CODE_FIELD_NAME].loading = productLineValidate.loading;
            cur[PRODUCT_LINE_CODE_FIELD_NAME].customErrorMsg = productLineValidate.errorMessage;
            return __assign({}, cur);
        });
    }, [productLineValidate.loading, productLineValidate.errorMessage]);
    useEffect(function () {
        setFieldValues(function (cur) {
            cur[DISCOUNT_CODE_FIELD_NAME].loading = discountCodeValidate.loading;
            cur[DISCOUNT_CODE_FIELD_NAME].customErrorMsg = discountCodeValidate.errorMessage;
            return __assign({}, cur);
        });
    }, [discountCodeValidate.loading, discountCodeValidate.errorMessage]);
    useEffect(function () {
        setFieldValues(function (cur) {
            cur[STANDARD_PRODUCT_REF_FIELD_NAME].loading = standardProductReferenceValidate.loading;
            cur[STANDARD_PRODUCT_REF_FIELD_NAME].customErrorMsg = standardProductReferenceValidate.errorMessage;
            return __assign({}, cur);
        });
    }, [standardProductReferenceValidate.loading, standardProductReferenceValidate.errorMessage]);
    /**
     * Called on Confirmation or Cancellation. On Confirm, updates Columns Definition with updated field values. Rests field values to Initial values from Column Definition
     */
    var handleAction = function (actionType) { return __awaiter(_this, void 0, void 0, function () {
        var cpn, sessionId, user, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.currentProduct)) {
                        return [2 /*return*/];
                    }
                    if (!(actionType === ActionType.CONFIRM)) return [3 /*break*/, 1];
                    postConfirmationUpdate();
                    return [3 /*break*/, 7];
                case 1:
                    if (!(actionType === ActionType.REVERT)) return [3 /*break*/, 2];
                    setFieldValues(buildFieldValues(cpaProductContext.data.currentProduct, cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn));
                    return [3 /*break*/, 7];
                case 2:
                    if (!(actionType === ActionType.EDIT)) return [3 /*break*/, 7];
                    cpn = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn;
                    sessionId = sessionStorage.getItem("".concat(cpn, "_identifier"));
                    if (!(cpn && sessionId)) return [3 /*break*/, 7];
                    return [4 /*yield*/, getUserOrSignIn()];
                case 3:
                    user = _a.sent();
                    _a.label = 4;
                case 4:
                    _a.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, createLock(cpn, user.name, sessionId, cpaProductContext.data.currentProduct.startDate)];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 7];
                case 6:
                    err_1 = _a.sent();
                    setBannerMessage("This record is locked because it's currently being edited by somone else. Please reload by clicking here: ");
                    setBannerType(BannerMessageType.Warning);
                    setBannerIcon(BannerIconType.Error);
                    setShowBanner(true);
                    setIsRefreshEnabled(true);
                    return [3 /*break*/, 7];
                case 7:
                    if (cpaProductContext.data.isEditDisabled) {
                        colDef.disabled = true;
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var postConfirmationUpdate = function () {
        updateCurrentProductCustomFields(colDef);
        cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.dispatch({
            type: 'UPDATE_CURRENT_PRODUCT',
            payload: __assign({}, cpaProductContext.data.currentProduct),
        });
    };
    function updateCurrentProductCustomFields(def) {
        if (!cpaProductContext || !cpaProductContext.data.currentProduct) {
            return;
        }
        Object.keys(fieldValues).forEach(function (propertyName) {
            if (cpaProductContext.data.currentProduct) {
                var currVal = fieldValues[propertyName].value;
                if (currVal) {
                    var _a = currVal.split(' '), code = _a[0], descriptionParts = _a.slice(1);
                    var description = descriptionParts.join(' ');
                    if (propertyName === PRODUCT_LINE_CODE_FIELD_NAME) {
                        cpaProductContext.data.currentProduct.productLineCode = code;
                        cpaProductContext.data.currentProduct.productLineDesc = description;
                    }
                    if (propertyName === DISCOUNT_CODE_FIELD_NAME) {
                        cpaProductContext.data.currentProduct.discountCode = code;
                        cpaProductContext.data.currentProduct.discountDesc = description;
                    }
                    if (propertyName === REQUESTOR) {
                        cpaProductContext.data.currentProduct.requestor = currVal;
                    }
                }
            }
        });
    }
    return colDef ? (_jsx(InputFieldsContainer, { colDef: colDef, handleAction: handleAction, fieldValues: fieldValues, setFieldValue: function (property, value) {
            setFieldValues(inputFieldsContainerHelper.getUpdatedFieldValues(fieldValues, property, value));
        }, labelFieldNameWidth: "160px", lineHeight: "40px" })) : (_jsx(LoadingSpinner, { indicatorSize: 10 }));
}
var buildFieldValues = function (cpaProduct, cpn) {
    var _a;
    var _b;
    return (_a = {},
        _a[PRODUCT_NAME] = {
            value: cpaProduct === null || cpaProduct === void 0 ? void 0 : cpaProduct.productName,
        },
        _a[DISCOUNT_CODE_FIELD_NAME] = {
            value: cpaProduct === null || cpaProduct === void 0 ? void 0 : cpaProduct.discountCode,
        },
        _a[PRODUCT_LINE_CODE_FIELD_NAME] = {
            value: cpaProduct === null || cpaProduct === void 0 ? void 0 : cpaProduct.productLineCode,
        },
        _a[STANDARD_PRODUCT_REF_FIELD_NAME] = {
            value: cpaProduct === null || cpaProduct === void 0 ? void 0 : cpaProduct.standardProductReference,
        },
        _a[CPN_FIELD_NAME] = {
            value: cpn,
        },
        _a[REQUESTOR] = {
            value: (_b = cpaProduct === null || cpaProduct === void 0 ? void 0 : cpaProduct.requestor) !== null && _b !== void 0 ? _b : '',
        },
        _a);
};
